// 组织管理路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/organization',
  component: Layout,
  children: [
    {
      path: 'salesGroup',
      component: () => import('@/view/organizationManagement/salesGroup'),
      name: '销售群组'
    },
    {
      path: 'store',
      component: () => import('@/view/organizationManagement/store'),
      name: '店铺'
    }
  ]
}
